export default __webpack_public_path__ + "static/media/logoSnippetShare.58f414b4.png";